import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-f5384a34"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "user-agreement"
};
import NavHeader from '@/views/components/NavHeader.vue';
import { agreement } from './type';
export default /*#__PURE__*/_defineComponent({
  __name: 'UserAgreement',

  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(NavHeader, {
        title: "机惠宝用户服务协议"
      }), _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(agreement) ? agreement.value = $event : null),
        class: "agreement-textarea",
        disabled: ""
      }, null, 512), [[_vModelText, _unref(agreement)]])]);
    };
  }

});